import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bToMb',
})
export class BToMbPipe implements PipeTransform {
  transform(value: number, precision: number = 2): number {
    return +(value / (1024 * 1024) + 0.005).toFixed(precision);
  }
}
